import React, { useEffect, useState } from "react";
import { freight } from "../../lib/freightApi.js";
import { useCarrier } from "./CarrierApp.jsx";
import { Shell, Back, Title, Card, Quiet, NotRunning, C, errText } from "./ui.jsx";
import { money } from "./reportsView.js";

/**
 * Billing (the schematic's Settings · Billing board): the plan, and who the bills go to, as we set
 * them. ⛔ NO PAYMENT PROCESSOR IS CONNECTED (backend billing.mjs): no card is on file and there are
 * no invoices, and the page says so instead of drawing them.
 */

export function BillingView({ company, stage, billing, error }) {
  const row = (label, value, muted) => (
    <div style={{ display: "flex", gap: "4px 16px", flexWrap: "wrap", padding: "12px 0", borderBottom: `1px solid ${C.soft}` }}>
      <dt style={{ minWidth: 140, color: C.muted }}>{label}</dt>
      <dd style={{ margin: 0, color: muted ? C.muted : C.ink }}>{value}</dd>
    </div>
  );
  return (
    <Shell company={company} stage={stage}>
      <Back to="/carrier/settings">Settings</Back>
      <Title>Billing</Title>
      {error && <Quiet>{error}</Quiet>}
      {!billing && !error && <Quiet>Loading…</Quiet>}
      {billing && (
        <>
          <Card style={{ padding: "8px 24px 16px" }}>
            <dl style={{ margin: 0, fontSize: 16 }}>
              {row("Plan", billing.plan ? `${billing.plan}${billing.priceCents != null ? `, ${money(billing.priceCents)} a month` : ""}` : "Not set yet: MuleWorks sets it with you", !billing.plan)}
              {row("Bills go to", billing.billingEmail || "Not set yet", !billing.billingEmail)}
              <div style={{ display: "flex", gap: "4px 16px", flexWrap: "wrap", alignItems: "center", padding: "12px 0" }}>
                <dt style={{ minWidth: 140, color: C.muted }}>Card</dt>
                <dd style={{ margin: 0, display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}><span>None on file</span><NotRunning>Adding a card is not connected yet</NotRunning></dd>
              </div>
            </dl>
          </Card>
          <Card style={{ padding: 24, display: "flex", flexDirection: "column", gap: 10 }}>
            <h2 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>Invoices</h2>
            <Quiet>None yet.</Quiet>
          </Card>
        </>
      )}
    </Shell>
  );
}

export default function Billing() {
  const { carrier } = useCarrier();
  const [billing, setBilling] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    let alive = true;
    freight.billing().then((b) => alive && setBilling(b)).catch((e) => alive && setError(errText(e)));
    return () => { alive = false; };
  }, []);
  return <BillingView company={carrier.name} stage={carrier.stage} billing={billing} error={error} />;
}
